/* eslint-disable valid-jsdoc */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
// redux utils
import { appImageActions } from 'redux-utils/actions';
import { connect } from 'react-redux';
// javascript utility for conditionally joining classNames together
import classNames from 'classnames';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import AppBar from '@material-ui/core/AppBar';
import Hidden from '@material-ui/core/Hidden';
import MenuItem from '@material-ui/core/MenuItem';
import Toolbar from '@material-ui/core/Toolbar';
import Fade from '@material-ui/core/Fade';
// core components
import Typography from 'components/Typography/Typography';
import Button from 'components/Button/Button';
import Menu from 'components/Menu/Menu';
import paygosLogo from 'assets/svg/paygos.svg';
import itStrategyLogo from 'assets/svg/it_strategy_logo.png';
// assets
import headerStyleNew from 'assets/jss/material-ui/components/headerStyleNew';
import { MenuIcon, PersonIcon, Home } from 'assets/icons/appIcons';
// storage
import ls from 'lib/core/storageFactory';

import { NavLink } from 'react-router-dom';
// icons
import { FaStoreAlt, FaChartBar, FaRegImages } from 'react-icons/fa';
import { MdOutlineViewQuilt, MdOutlineDescription } from 'react-icons/md';
import { BsDatabaseFillCheck } from 'react-icons/bs';
import { AiOutlineAppstore } from 'react-icons/ai';
import { IoAnalyticsOutline } from 'react-icons/io5';
import { IoIosArrowDown } from 'react-icons/io';
import { track } from 'analytics';
import { INFISUITE_EVENTS, HEADER_EVENTS } from 'analytics/events';

const getPathName = props => {
  let name;
  props.routes.map(prop => {
    if (prop.path === props.location.pathname) {
      name = prop.navbarName;
    }
    return null;
  });
  return name;
};

// Mapping and helper to rename header display names
const headerRenameMap = {
  'App Images': 'Session Images',
  Analytics: 'HQ Analytics',
  'Test Store Explorer': 'Data Quality Studio'
};

const renameHeaderLabel = (label, routeID) => {
  return headerRenameMap[label] || label;
};

const generateRightMenuItems = ({
  routes,
  handleRouteClick,
  handleLogout,
  handleProfileClose
}) => {
  const client = ls.get('client') || '';
  const clientResponse = ls.get('clientResponse');
  const showResetPasswordLs = ls.get('showResetPassword');
  const menuItems = [];
  routes.map(route => {
    if (!route.redirect) {
      menuItems.push(
        <MenuItem key={route.path} onClick={() => handleRouteClick(route)}>
          {renameHeaderLabel(route.navbarName, route.routeID)}
        </MenuItem>
      );
    }
    return route;
  });
  menuItems.push(
    <MenuItem key={1} onClick={() => handleProfileClose('logout')}>
      {client.includes('kcc-ru') ? 'Выйти из системы' : 'Logout'}
    </MenuItem>
  );
  try {
    // updated this condition to show reset password for all users logging with username and password
    if (showResetPasswordLs) {
      menuItems.push(
        <MenuItem key={2} onClick={() => handleProfileClose('reset')}>
          {client.includes('kcc-ru') ? 'Reset Password' : 'Reset Password'}
        </MenuItem>
      );
    }
  } catch (error) {
    handleLogout();
  }

  return menuItems;
};

const Brand = ({ classes, logo }) => {
  const client = ls.get('client') || '';
  return (
    <div>
      <a href="/app/sessions">
        <div
          className={
            client === 'brandmomentum-0525-poc'
              ? classes.paygosLogoImage
              : client === 'it-strategy-2025'
              ? classes.itStrategyLogoImage
              : classes.logoImage
          }
        >
          <img
            src={
              client === 'brandmomentum-0525-poc'
                ? paygosLogo
                : client === 'it-strategy-2025'
                ? itStrategyLogo
                : logo
            }
            alt="logo"
          />
        </div>
      </a>
    </div>
  );
};

const StyledAppBar = styled(AppBar)`
  background-color: ${props =>
    props.bg ? `${props.bg} !important` : 'oklch(0.21 0.12 284.9) !important'};
`;

const StyledDiv = styled.div`
  && path {
    fill: ${props => props.color};
  }
`;

/**
 * @class
 * @hideconstructor
 * @description Page AppHeader class component
 */
class AppHeader extends Component {
  state = {
    profEl: null,
    internalMenuEl: null
  };

  handleProfileClick = event => {
    track(HEADER_EVENTS.PROFILE_MENU_OPENED, {});
    this.setState({ profEl: event.currentTarget });
  };

  handleRouteClick = route => {
    track(HEADER_EVENTS.PROFILE_ACTION, { action: 'route', route_path: route.path });
    this.props.history.push(route.path);
    this.setState({ profEl: null });
  };

  handleHomeClick = () => {
    track(HEADER_EVENTS.HOME_CLICKED, {});
    const { initializeAppImages } = this.props;
    this.props.history.push('/app');
    initializeAppImages();
    this.setState({ profEl: null });
  };

  handleProfileClose = option => {
    track(HEADER_EVENTS.PROFILE_ACTION, {
      action: option === 'logout' ? 'logout' : 'reset_password'
    });
    if (option === 'logout') {
      this.props.handleLogout();
    }
    if (option === 'reset') {
      this.props.history.push('/reset_password');
    }
    this.setState({ profEl: null });
  };

  handleInternalMenuClick = event => {
    event.preventDefault();
    event.stopPropagation();
    // Toggle menu on click - if already open, close it; otherwise open it
    if (this.state.internalMenuEl) {
      this.closeInternalMenu();
    } else {
      this.menuOpenedByClick = true;
      this.setState({ internalMenuEl: event.currentTarget });
    }
  };

  handleInternalMenuHover = event => {
    // Clear any pending close timeout when re-entering button
    if (this.menuLeaveTimeout) {
      clearTimeout(this.menuLeaveTimeout);
      this.menuLeaveTimeout = null;
    }
    // Only open on hover if menu wasn't opened by click
    if (!this.menuOpenedByClick) {
      this.setState({ internalMenuEl: event.currentTarget });
    }
  };

  handleInternalMenuLeave = () => {
    // Only auto-close on hover leave if menu wasn't opened by click
    if (!this.menuOpenedByClick) {
      // Clear any existing timeout first
      if (this.menuLeaveTimeout) {
        clearTimeout(this.menuLeaveTimeout);
      }
      // Set a longer delay to allow moving to menu
      this.menuLeaveTimeout = setTimeout(() => {
        if (!this.menuHovered && !this.menuOpenedByClick) {
          this.closeInternalMenu();
        }
      }, 800);
    }
  };

  handleMenuEnter = () => {
    this.menuHovered = true;
    // Clear any pending close timeout immediately when entering menu
    if (this.menuLeaveTimeout) {
      clearTimeout(this.menuLeaveTimeout);
      this.menuLeaveTimeout = null;
    }
  };

  handleMenuLeave = () => {
    this.menuHovered = false;
    // Only close if menu wasn't opened by click
    // Add a small delay to allow re-entering the button
    if (!this.menuOpenedByClick) {
      this.menuLeaveTimeout = setTimeout(() => {
        if (!this.menuHovered && !this.menuOpenedByClick) {
          this.closeInternalMenu();
        }
      }, 500);
    }
  };

  closeInternalMenu = () => {
    this.setState({ internalMenuEl: null });
    this.menuHovered = false;
    this.menuOpenedByClick = false;
    if (this.menuLeaveTimeout) {
      clearTimeout(this.menuLeaveTimeout);
      this.menuLeaveTimeout = null;
    }
  };

  handleInternalMenuSelect = option => {
    const destinationMap = {
      'infi-suite': '/app/infi-suite',
      'infilytics': '/app/infilytics',
      'integration-docs': 'https://docs.infiviz.ai',
      'infidocs': 'https://infidocs.infiviz.ai/',
      'infihub': 'https://infihub.infiviz.ai/',
    };

    track(INFISUITE_EVENTS.MENU_ITEM_SELECTED, {
      menu_item: option,
      destination_url: destinationMap[option] || option,
    });

    switch (option) {
      case 'infi-suite':
        window.location.href = '/app/infi-suite';
        break;
      case 'infilytics':
        window.location.href = '/app/infilytics';
        break;
      case 'integration-docs':
        window.open('https://docs.infiviz.ai', '_blank');
        break;
      case 'infidocs':
        window.open('https://infidocs.infiviz.ai/', '_blank');
        break;
      case 'infihub':
        window.open('https://infihub.infiviz.ai/', '_blank');
        break;
      default:
        break;
    }
    this.closeInternalMenu();
  };

  render() {
    const {
      classes,
      color,
      handleLogout,
      handleDrawerToggle,
      rightMenuRoutes,
      useHomeIcon,
      handleDrawerExpand,
      icon: ViewIcon,
      clientPreferences,
      headerStyles,
      tseWorkflow
    } = this.props;

    const { profEl, internalMenuEl } = this.state;
    const appBarClasses = classNames({
      [` ${classes[color]}`]: color
    });
    const profileOpen = Boolean(profEl);
    const menuRoutes = this.props?.menuRoutes || [];
    const hasDQS = menuRoutes.some(
      item =>
        item?.routeID === 'test-store-explorer' ||
        (item?.sidebarName || item?.navbarName) === 'Test Store Explorer' ||
        (item?.path || '').includes('test-store-explorer')
    );
    const hasInfilytics = menuRoutes.some(
      item =>
        item?.routeID === 'infilytics' ||
        (item?.sidebarName || '').toLowerCase().includes('infilytics') ||
        (item?.path || '').includes('infilytics')
    );
    const isInternalUser = hasDQS || hasInfilytics;
    const hasHQAnalytics = menuRoutes.some(
      item =>
        (item?.routeID || '').toLowerCase().includes('analytics') ||
        (item?.navbarName || item?.sidebarName || '')
          .toLowerCase()
          .includes('analytics') ||
        (item?.path || '').includes('analytics-redirect')
    );

    const isActivePath = path =>
      (this.props.location?.pathname || '').indexOf(path) > -1;
    const getBtnClass = path =>
      classNames(classes.navButton, {
        [classes.navButtonActive]: isActivePath(path)
      });
    return (
      <StyledAppBar
        className={classes.appBar + appBarClasses}
        bg={headerStyles?.backgroundColor}
      >
        <Toolbar className={classes.container}>
          <div className={classes.flex}>
            <Brand {...this.props} />
            <div className={classes.navButtonsContainer}>
              <button
                className={getBtnClass('/app/sessions')}
                onClick={() => {
                  track(HEADER_EVENTS.NAV_CLICKED, {
                    destination: 'Store Explorer',
                    destination_url: '/app/sessions'
                  });
                  window.location.href = '/app/sessions';
                }}
              >
                <FaStoreAlt />
                <span>Store Explorer</span>
              </button>

              <button
                className={getBtnClass('/app/store-explorer-v2')}
                onClick={() => {
                  const search = window.location.search || '';
                  const url = '/app/store-explorer-v2' + search;
                  track(HEADER_EVENTS.NAV_CLICKED, {
                    destination: 'Session Viewer',
                    destination_url: url
                  });
                  window.location.href = url;
                }}
              >
                <MdOutlineViewQuilt />
                <span>Session Viewer</span>
              </button>

              <button
                className={getBtnClass('/app/app-images')}
                onClick={() => {
                  const search = window.location.search || '';
                  const url = '/app/app-images' + search;
                  track(HEADER_EVENTS.NAV_CLICKED, {
                    destination: 'Session Images',
                    destination_url: url
                  });
                  window.location.href = url;
                }}
              >
                <FaRegImages />
                <span>Session Images</span>
              </button>

              {isInternalUser && (
                <button
                  className={getBtnClass('/app/test-store-explorer')}
                  onClick={() => {
                    const search = window.location.search || '';
                    const url = '/app/test-store-explorer' + search;
                    track(HEADER_EVENTS.NAV_CLICKED, {
                      destination: 'Data Quality Studio',
                      destination_url: url
                    });
                    window.location.href = url;
                  }}
                >
                  <BsDatabaseFillCheck />
                  <span>Data Quality Studio</span>
                </button>
              )}

              {hasHQAnalytics && (
                <button
                  className={getBtnClass('/app/analytics-redirect')}
                  onClick={() => {
                    track(HEADER_EVENTS.NAV_CLICKED, {
                      destination: 'HQ Analytics',
                      destination_url: '/app/analytics-redirect'
                    });
                    window.location.href = '/app/analytics-redirect';
                  }}
                >
                  <FaChartBar />
                  <span>HQ Analytics</span>
                </button>
              )}

              {isInternalUser && (
                <>
                  <button
                    className={classes.navButton}
                    onClick={this.handleInternalMenuClick}
                    onMouseEnter={this.handleInternalMenuHover}
                    onMouseLeave={this.handleInternalMenuLeave}
                  >
                    <AiOutlineAppstore />
                    <span>InfiSuite</span>
                    <IoIosArrowDown style={{ marginLeft: 4, fontSize: '0.9em' }} />
                  </button>
                  <Menu
                    id="internal-menu"
                    anchorEl={internalMenuEl}
                    handleClose={this.closeInternalMenu}
                    onMouseEnter={this.handleMenuEnter}
                    onMouseLeave={this.handleMenuLeave}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'right'
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'right'
                    }}
                    disableContentAnchor
                    transitionComponent={Fade}
                    transitionProps={{ timeout: { enter: 200, exit: 150 } }}
                  >
                    <MenuItem
                      onClick={() =>
                        this.handleInternalMenuSelect('infi-suite')
                      }
                    >
                      <AiOutlineAppstore style={{ marginRight: 8 }} />
                      InfiSuite
                    </MenuItem>
                    <MenuItem
                      onClick={() => this.handleInternalMenuSelect('infilytics')}
                    >
                      <IoAnalyticsOutline style={{ marginRight: 8 }} />
                      InFilytics
                    </MenuItem>
                    <MenuItem
                      onClick={() =>
                        this.handleInternalMenuSelect('integration-docs')
                      }
                    >
                      <MdOutlineDescription style={{ marginRight: 8 }} />
                      Integration Docs
                    </MenuItem>
                    <MenuItem
                      onClick={() =>
                        this.handleInternalMenuSelect('infidocs')
                      }
                    >
                      <img
                        src="/infidocs.png"
                        alt="InfiDocs"
                        style={{
                          marginRight: 8,
                          width: 16,
                          height: 16,
                          objectFit: 'contain'
                        }}
                      />
                      InfiDocs
                    </MenuItem>
                    <MenuItem
                      onClick={() =>
                        this.handleInternalMenuSelect('infihub')
                      }
                    >
                      <img src="/infihub.png" alt="InfiHub" style={{ marginRight: 8, width: 16, height: 16, objectFit: 'contain' }} />
                      InfiHub
                    </MenuItem>
                  </Menu>
                </>
              )}
            </div>
            <Hidden 
              className={classes.rightFlexContainer}
              smDown
              implementation="css"
            >
              <div style={{ display: 'flex' }}>
                {useHomeIcon && (
                  <Button
                    className={classes.menuButtonRight}
                    color="dark"
                    round
                    justIcon
                    onClick={this.handleHomeClick}
                  >
                    <Home />
                  </Button>
                )}
                {clientPreferences.client_logo &&
                clientPreferences.client_logo.show ? (
                  <div className={classes.logoContainer}>
                    <img
                      alt="client logo"
                      src={
                        clientPreferences.client_logo
                          ? clientPreferences.client_logo.logo
                          : ''
                      }
                    />
                  </div>
                ) : null}

                <Button
                  className={useHomeIcon ? '' : classes.menuButtonRightPerson}
                  aria-haspopup="true"
                  aria-owns={profileOpen ? 'profile-menu' : undefined}
                  aria-label="open profile"
                  color="dark"
                  round
                  justIcon
                  onClick={this.handleProfileClick}
                >
                  <PersonIcon />
                </Button>
              </div>
            </Hidden>
            <Hidden mdUp implementation="css">
              <Button
                className={classes.menuButton}
                aria-label="open drawer"
                color="dark"
                round
                justIcon
                onClick={handleDrawerToggle}
              >
                <MenuIcon />
              </Button>
            </Hidden>
            <Menu
              id="menu-profile"
              anchorEl={profEl}
              handleClose={this.handleProfileClose}
            >
              {generateRightMenuItems({
                routes: rightMenuRoutes,
                handleProfileClose: this.handleProfileClose,
                handleRouteClick: this.handleRouteClick,
                handleLogout
              }).map(RightMenu => RightMenu)}
            </Menu>
          </div>
        </Toolbar>
      </StyledAppBar>
    );
  }
}

// component properties
AppHeader.propTypes = {
  /**
   * @type {object}
   * @description Class names of the styles generated with jss
   */
  classes: PropTypes.object.isRequired,
  /**
   * @type {object}
   * @description browser history object
   */
  history: PropTypes.object.isRequired,
  /**
   * @type {object}
   * @description Class names of the styles generated with jss
   */
  rightMenuRoutes: PropTypes.array.isRequired,

  useHomeIcon: PropTypes.bool,
  /**
   * @type {string}
   * @description App bar color
   */
  color: PropTypes.oneOf([
    'primary',
    'info',
    'success',
    'warning',
    'danger',
    ''
  ]),
  /**
   * @type {function}
   * @description Handler function to handle the drawer toggle on md devices
   */
  handleDrawerToggle: PropTypes.func,
  /**
   * @type {function}
   * @description Handler function to handle the user logout
   */
  handleLogout: PropTypes.func.isRequired,
  /**
   * @type {function}
   * @description Redux function to initialize the app images state
   */
  initializeAppImages: PropTypes.func.isRequired,
  /**
   * @type {function}
   * @description Drawer open icon
   */
  icon: PropTypes.object.isRequired,
  /**
   * @type {function}
   * @description Handler function to handle the drawer open on sm devices
   */
  handleDrawerExpand: PropTypes.func.isRequired,
  clientPreferences: PropTypes.object.isRequired,
  headerStyles: PropTypes.object.isRequired
};

AppHeader.defaultProps = {
  color: '',
  handleDrawerToggle: () => {},
  useHomeIcon: false
};

Brand.propTypes = {
  classes: PropTypes.object.isRequired,
  logo: PropTypes.string.isRequired
};

const mapDispatchToProps = dispatch => {
  return {
    initializeAppImages: payload =>
      dispatch(appImageActions.initializeAppImages(payload))
  };
};

export default connect(
  null,
  mapDispatchToProps
)(withStyles(headerStyleNew)(AppHeader));
